import type { RawResponse } from '../type';

export enum ENHANCE_TYPE {
    /** 标清 */
    SD = 'SD',
    /** 高清 */
    HD = 'HD',
    /** 超清 */
    HDU = 'HDU',
    /** 海外超清 */
    HDUV2 = 'HDUV2',
    /** AI超清 */
    AIHDU = 'AIHDU',
    /** 商品单独品类 */
    PRODUCT = 'PRODUCT',
    /** 文字单独品类 */
    TEXT = 'TEXT',
    /** 人像单独品类 */
    PORTRAIT = 'PORTRAIT',
}
export type ImageRecognitionResult = 'product' | 'text' | 'other';

export type ImageEnhanceResult = {
    result: string;
    width: number;
    height: number;
    duration: string;
    projectId?: number;
    taskId?: string;
};

export type ImageEnhanceParams = {
    type: ENHANCE_TYPE;
    // ai超清，去掉识别
    removeCls?: boolean;
    url: string;
    queryParams?: Record<string, any>;
    file?: File;
    transfer?: string;
    transferID?: string;
};

export type ImageRestorationResponse = RawResponse<{
    msg_id: string;
    project_id?: number;
}>;

export type ImageResultResponse = RawResponse<{
    parameter: {
        version: string;
        spend_time: string;
    };
    media_info_list: [
        {
            media_data: string;
            media_profiles: {
                media_data_type: string;
                media_data_height: number;
                media_data_size: number;
                media_data_width: number;
            };
            media_extra: {};
        },
    ];
    error_code: number;
    error_msg: string;
    msg_id: string;
}>;

export type ImageResultBatchResponse = RawResponse<
    {
        duration?: {
            alg_process_time: number;
            created_timestamp: number;
            pull_timestamp: number;
            waiting_time: number;
        };
        parameter: {
            version: string;
            spend_time: string | number;
        };
        media_info_list?: [
            {
                media_data: string;
                media_profiles: {
                    media_data_type: string;
                    media_data_height: number;
                    media_data_size: number;
                    media_data_width: number;
                };
                media_extra: {};
            },
        ];
        err_code: number;
        err: string;
        msg_id: string;
    }[]
>;

export type ImageEnhanceBatchParams = {
    type: ENHANCE_TYPE;
    // ai超清，去掉识别
    removeCls?: boolean;
    urls: string[];
    transfer?: string;
    transferID?: string;
    queryParams?: Record<string, any>;
    onQuery: (tasks: ImageEnhanceBatchTask[]) => void;
    onQuerySuccess?: (tasks: ImageEnhanceBatchTask[]) => void;
    onQueryFailed?: () => void;
};

export type LoopParams = {
    tasks: ImageEnhanceBatchTask[];
    ids: string[];
    onQuery: (tasks: ImageEnhanceBatchTask[]) => void;
    onQuerySuccess?: (tasks: ImageEnhanceBatchTask[]) => void;
    type: ENHANCE_TYPE;
};

export type TaskStatus = 'pending' | 'success' | 'failed';

export type ImageEnhanceBatchTask = {
    url: string;
    status: TaskStatus;
    taskId?: string;
    projectId?: number;
    result?: string;
    width?: number;
    height?: number;
    duration?: string;
};
export type ImageRecognitionResultBatchResponse = RawResponse<{
    parameter: {
        version: string;
        rsp_media_type: string;
    };
    media_info_list: {
        media_data: [
            {
                ID3: number;
                ID2: number;
                ID1: number;
                ChineseLabel3: string;
                EnglishLabel3: string;
                ChineseLabel2: string;
                EnglishLabel2: string;
                ChineseLabel1: string;
                EnglishLabel1: string;
                Score: number;
            },
        ];
        media_profiles: {
            media_data_type: string;
        };
    }[];
}>;
